import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus } from "react-feather";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal, ModalBody, ModalFooter, ModalHeader, Label
} from "reactstrap";
import SingleSelect from "../../SingleSelect/SingleSelect";
import { Btn, H5 } from "../../../AbstractElements";
import axios from "axios";

const user_options = ["Name", "Phone Number"];

const FilterComponent = ({ filterText, onFilter, onClear, t,  userOption,
  setSelectedUserOption }) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
  <SingleSelect
    options={user_options}
    selectedOption={userOption}
    onChange={setSelectedUserOption}
  />
    <input
      className="form-control"
      placeholder={userOption === 'Name'? t("Filter by Name") : t("Filter by Phone Number") }
      aria-label="Search Input"
      style={{ width: '250px', paddingLeft: '5px' }}
      name="phone"
      id="search"
      type="text"
      value={filterText}
      onChange={onFilter}
    />
    <Btn
    attrBtn={{onClick: onClear }}
    type="button"
    >
      X
    </Btn>
  </div>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const { t } = useTranslation();
  const [user_id, setUserId] = useState();
  const pres = localStorage.getItem("pres");
  const [modal, setModal] = useState(false);
  const [userOption, setSelectedUserOption] = useState("Member");
  const [userOption2, setSelectedUserOption2] = useState("Member");
  const toggle = (e) => {
    e.preventDefault()
    setModal(!modal)
  };
  const [filteredItems, setFilteredItems] = useState();
  useEffect(() => {
    handle_get_firms();
  }, []);

  const user_options = [
    "NADA Office",
    "President",
    "Member",
    "Office Bearer",
    "General Secretary",
    "Executive Member"
  ]

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/users", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        setData(response2?.data?.data?.users);
        setFilteredItems(response2?.data?.data?.users);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Btn attrBtn={{ color: "danger", onClick: handleDelete }} key="delete">
        Delete
      </Btn>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to delete:\r ${selectedRows.map((r) => r.name)}?`
      )
    ) {
      setToggleCleared(!toggleCleared);
      setData(differenceBy(data, selectedRows, "name"));
      toast.success("Successfully Deleted !");
    }
  };

  function ComponentEdit({ row }) {

    return (
      <span style={{ display: "flex", flexDirection: "row", gap: 10 }}>
      <div onClick={(e) =>  {
        setUserId(row?.id)
        toggle(e)
      }}>
        <Edit />
      </div>
     { /*<div onClick={(e) => handleDelete(row?.id, e)}>
        <Trash2 color="#e52727" />
      </div>*/}
    </span>
    );
  }

  const handleAddNewClick = () => {
    navigate("/firm/add");
  };

  const renderStatusBadge = (status, status2, status3, status4, status5) => {

    if(status2) {
      return <Badge color="primary">President</Badge>;
    } else if(status3) {
      return <Badge color="secondary">Office Bearer</Badge>;
    } else if(status4) {
      return <Badge color="secondary">General Secretary</Badge>;
    } else if(status5) {
      return <Badge color="secondary">Executive Member</Badge>;
    } else if(status) {
      return <Badge color="secondary">NADA Office</Badge>;
    } else {
        return <Badge color="warning">Member</Badge>;
    }
  };

  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };

  const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name"),
      selector: (Row) => Row["name"],
      sortable: true,
      center: true,
    },
    {
      name: t("Phone Number"),
      selector: (Row) => Row["phone_number"],
      sortable: true,
      center: true,
    },
    {
      name: t("Status"),
      selector: (Row) => renderStatusBadge(Row["admin"], Row["pres"], Row["office_bear"], Row["general"], Row["executive"]),
      sortable: true,
      center: true,
    },
    pres === 'false'? { name: t("Actions"), cell: (row) => <ComponentEdit row={row} /> } : ''
  ];

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === '') {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        userOption === "Name"
        ? data?.filter((item) =>
            item?.name?.toLowerCase()?.includes(filterText?.toLowerCase())
          )
        : userOption === "Phone Number"
        ? data?.filter((item) =>
          item?.phone_number?.toLowerCase()?.includes(filterText?.toLowerCase())
        )
        : null
      );
    }

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        t={t}
        userOption={userOption}
        setSelectedUserOption={setSelectedUserOption}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle, userOption]);

  const handle_user_update = async (e) => {
    e.preventDefault();
    if(user_id) {
    try {
      const response2 = await axios.post(
        "https://api-portal.nada.org.np/api/users/status",
        {
          admin: userOption2 === 'NADA Office' || userOption2 === 'President' || userOption2 === "Office Bearer" || userOption2 === "General Secretary" || userOption2 ===  "Executive Member"? true : false,
          pres: userOption2 === 'President'? true : false,
          id: user_id,
          office_bear: userOption2 === "Office Bearer"? true : false,
          general: userOption2 === "General Secretary"? true : false,
          executive: userOption2 === "Executive Member"? true : false,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        },
      );

      if (response2?.data?.success) {
        toast.success(response2?.data?.message);
        setModal(!modal);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  }
  };

  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t('Users')}</H5>
                {/*<Btn
                  attrBtn={{ color: "primary", onClick: handleAddNewClick }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Add New
                </Btn>*/}
              </CardHeader>
              <CardBody>
                {data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    selectableRows
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modal} toggle={toggle}
      //size={props.size}
      centered
      >
      <ModalHeader toggle={toggle}>
      {t("Update User Role")}
      </ModalHeader>
      <ModalBody
      //className={props.bodyClass}
      >
      <SingleSelect
                  options={user_options}
                  selectedOption={userOption2}
                  onChange={setSelectedUserOption2}
                />
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: 'secondary', onClick: toggle, height: 65 }} >{t("Close")}</Btn>
        <Btn attrBtn={{ color: 'primary', onClick: (e)=> handle_user_update(e), outerHeight: 65 }}>{t("Update")}</Btn>
      </ModalFooter>
    </Modal>
    </Fragment>
  );
};
export default DataTablesContain;
